import React from 'react';
import { Field, useFormikContext } from 'formik';
import styled from 'styled-components';
import TextInputField from './TextInputField';
import { useIntl } from 'react-intl';
import { camelCase } from 'lodash';
import { howHeardTypeOptions } from './howHeardTypeOptions';
import common from 'javascripts/helpers/intl-common';
import { ChevronDown } from '../../shared/DesignSystem/Icons';

const HowHeardDetailsView = styled.div`
  margin-top: 16px;
`;
const IconWrapper = styled.div`
  margin-right: 6px;
`;

const HowHeard = () => {
  const { formatMessage } = useIntl();
  const { values } = useFormikContext();
  const howHeardOptions = [
    {
      type: formatMessage(howHeardTypeOptions.selectOne),
      value: '',
      disabled: true,
    },
    {
      type: formatMessage(common.otherTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.otherDetail),
    },
    {
      type: formatMessage(howHeardTypeOptions.podcastTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.podcastDetail),
    },
    {
      type: formatMessage(howHeardTypeOptions.softwareTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.softwareDetail),
    },
    {
      type: formatMessage(howHeardTypeOptions.socialTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.socialDetail),
    },
    {
      type: formatMessage(howHeardTypeOptions.someoneTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.someoneDetail),
    },
    {
      type: formatMessage(howHeardTypeOptions.tradeTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.tradeDetail),
    },
    {
      type: formatMessage(howHeardTypeOptions.manufacturerTitle),
      detailQuestion: formatMessage(howHeardTypeOptions.manufacturerDetail),
    },
  ];

  const howHeardDetailQuestion =
    values.howHeardType &&
    howHeardOptions.find((option) => option.type === values.howHeardType)
      ?.detailQuestion;

  return (
    <div className="form-field">
      <div className="input-wrap ">
        <div className="input-wrap input-wrap--withicon">
          <Field
            as="select"
            name="howHeardType"
            className="select-new-signup"
            data-testid="signup__howHeard"
          >
            {howHeardOptions.map((option) => (
              <option
                key={option.type}
                value={option.value ?? option.type}
                disabled={option.disabled}
                data-testid={`signup__howHeard-${camelCase(option.type)}`}
              >
                {option.type}
              </option>
            ))}
          </Field>
          <label htmlFor="howHeard">
            {formatMessage(howHeardTypeOptions.defaultOption)}
          </label>
          <IconWrapper>
            <ChevronDown size={20} color="#707B86" />
          </IconWrapper>
        </div>
        {values.howHeardType ? (
          <HowHeardDetailsView>
            <TextInputField
              showClearIcon
              name="howHeardDetail"
              type="text"
              placeholder={howHeardDetailQuestion}
            />
          </HowHeardDetailsView>
        ) : null}
      </div>
    </div>
  );
};

export default HowHeard;
